import { render, staticRenderFns } from "./finantial-settings-payout-methods-card.vue?vue&type=template&id=0adef7ea&scoped=true&"
import script from "./finantial-settings-payout-methods-card.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-payout-methods-card.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-payout-methods-card.vue?vue&type=style&index=0&id=0adef7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adef7ea",
  null
  
)

export default component.exports